import { useGetFulfillmentpartners } from 'api/generated/fulfillment-partner/fulfillment-partner'
import type { FulfillmentPartnerStaffApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

// Wraps the Orval-generated GET /api/v1/fulfillmentpartners hook so the data
// source is swappable from one place. Consumers use the generated contract
// directly. Read-only: the provider view never mutates partners.
export function useProviderFulfillmentPartners(): {
  data: FulfillmentPartnerStaffApiOutContract[]
  isLoading: boolean
} {
  const { data, isLoading } = useGetFulfillmentpartners()
  return { data: data ?? [], isLoading }
}
